import React, { Children, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '../core/theming';
import Div from './Div';

/* eslint-disable react/prop-types */

const Tab = ({ activeColor, hoverColor, borderColor, paneProps, children, selectedCode, ...rest }) => {
  const panes = useMemo(() => Children.toArray(children), [children]);
  return (
    <>
      <Div border={{ y: '1px solid' }} borderColor={borderColor} d="flex" {...rest}>
        {panes.map((pane) => (
          <Div
            key={pane.props.code}
            p={{ x: '8px', y: '12px' }}
            borderColor={selectedCode === pane.props.code ? activeColor : 'transparent'}
            {...paneProps}
            cursor="pointer"
            border={{ b: '4px solid' }}
            onClick={() => {
              pane.props.onSelect();
            }}
            hoverBorderColor={selectedCode === pane.props.code ? activeColor : hoverColor}
          >
            {pane.props.name}
          </Div>
        ))}
      </Div>
      <>
        {panes
          .filter((pane) => selectedCode === pane.props.code)
          .map((pane) => React.createElement(Div, pane.props, pane.props.children))}
      </>
    </>
  );
};

Tab.propTypes = {
  borderColor: PropTypes.string,
  activeColor: PropTypes.string,
  hoverColor: PropTypes.string,
  bg: PropTypes.string,
  paneProps: PropTypes.shape({}),
  selectedCode: PropTypes.string,
};

Tab.defaultProps = {
  borderColor: 'black50',
  activeColor: 'brand500',
  hoverColor: 'gray600',
  bg: 'gray200',
  paneProps: {},
  selectedCode: '',
};

export default withTheme(Tab);
